import { createColumnHelper } from "@tanstack/react-table";
import { Checkbox } from "@mui/material";
import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { MoreVertical } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks";
import { setCaseDetailModal } from "../../../../states/slices/globalReducer";

const columnHelper = createColumnHelper<any>();

const ActionMenu = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  return (
    <Menu as="div" className="relative inline-block text-left">
      <Menu.Button className="p-2 text-[#98A2B3] hover:text-[#475467] transition-colors focus:outline-none">
        <MoreVertical className="w-5 h-5" />
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          anchor="bottom end"
          className="absolute right-0 z-50 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
        >
          <div className="py-1">
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={() => navigate("/panel/joinder-request/view")}
                  className={`${
                    active ? "bg-[#ECFDF3] text-[#027A48]" : "text-[#344054]"
                  } group flex w-full items-center px-4 py-2 text-sm`}
                >
                  Open folder
                </button>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={() => dispatch(setCaseDetailModal(true))}
                  className={`${
                    active ? "bg-[#ECFDF3] text-[#027A48]" : "text-[#344054]"
                  } group flex w-full items-center px-4 py-2 text-sm`}
                >
                  View case details
                </button>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <button
                  className={`${
                    active ? "bg-[#ECFDF3] text-[#027A48]" : "text-[#344054]"
                  } group flex w-full items-center px-4 py-2 text-sm`}
                >
                  Query
                </button>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={() => navigate("/panel/joinder-request/view")}
                  className={`${
                    active ? "bg-[#ECFDF3] text-[#027A48]" : "text-[#344054]"
                  } group flex w-full items-center px-4 py-2 text-sm`}
                >
                  View request
                </button>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export const PanelJoinderRequestColumns = [
  columnHelper.accessor("sn", {
    header: "SN",
    cell: ({ row }) => (
      <Checkbox
        color="success"
        checked={row.getIsSelected()}
        onChange={row.getToggleSelectedHandler()}
        sx={{
          color: "#E0E0E0",
          "&.Mui-checked": {
            color: "#00B074",
          },
        }}
      />
    ),
  }),
  columnHelper.accessor("title", {
    header: "Title",
    cell: (info) => (
      <span
        className="text-[#101828] font-medium max-w-[260px] truncate block"
        title={info.getValue()}
      >
        {info.getValue()}
      </span>
    ),
  }),
  columnHelper.accessor("date_submitted", {
    header: "Date submitted",
    cell: (info) => <span className="text-[#667085]">{info.getValue()}</span>,
  }),
  columnHelper.accessor("appeal_number", {
    header: "Appeal Number",
    cell: (info) => <span className="text-[#667085]">{info.getValue()}</span>,
  }),
  columnHelper.accessor("joining_as", {
    header: "Joining as",
    cell: (info) => <span className="text-[#667085]">{info.getValue()}</span>,
  }),
  columnHelper.accessor("status", {
    header: "Status",
    cell: (info) => (
      <span className="text-[#00B074] font-medium">{info.getValue()}</span>
    ),
  }),
  columnHelper.accessor("requester_name", {
    header: "Requester name",
    cell: (info) => <span className="text-[#667085]">{info.getValue()}</span>,
  }),
  columnHelper.display({
    id: "actions",
    header: "Action",
    cell: () => <ActionMenu />,
  }),
];
